import { GridSortItem } from "@mui/x-data-grid";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientAssessmentControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  patientId?: string;
  xTENANTID?: string;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author [Rajkumar Rathod]
 */
export const usePatientAssessmentList = ({
  pagination,
  gridSorting,
  patientId,
  xTENANTID,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });
  const pageSize = getPageSize("", pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "all-screening-list",
      patientId,
      pageIndex,
      pageSize,
      gridSorting,
      xTENANTID,
      sortData,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientAssessmentControllerApi(getConfigObject())
        .getAllPatientAssessments(
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          patientId,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
